/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RateRefundableSource } from './RateRefundableSource';
import {
    RateRefundableSourceFromJSON,
    RateRefundableSourceFromJSONTyped,
    RateRefundableSourceToJSON,
    RateRefundableSourceToJSONTyped,
} from './RateRefundableSource';

/**
 * Minimal response carrying a rate's refundable status plus the free-cancel offset days
 * @export
 * @interface RateRefundableResponseV2
 */
export interface RateRefundableResponseV2 {
    /**
     * null when the rate is unresolvable (e.g. not in raw_rate_summaries) or when Travelport's get_terms returned no signal.
     * @type {boolean}
     * @memberof RateRefundableResponseV2
     */
    refundable?: boolean | null;
    /**
     * Days before check-in the free-cancel deadline falls. null when refundable is false, or when the cancellation text had no parseable date.
     * @type {number}
     * @memberof RateRefundableResponseV2
     */
    cancelOffsetDays?: number | null;
    /**
     * 
     * @type {RateRefundableSource}
     * @memberof RateRefundableResponseV2
     */
    source: RateRefundableSource;
}



/**
 * Check if a given object implements the RateRefundableResponseV2 interface.
 */
export function instanceOfRateRefundableResponseV2(value: object): value is RateRefundableResponseV2 {
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function RateRefundableResponseV2FromJSON(json: any): RateRefundableResponseV2 {
    return RateRefundableResponseV2FromJSONTyped(json, false);
}

export function RateRefundableResponseV2FromJSONTyped(json: any, ignoreDiscriminator: boolean): RateRefundableResponseV2 {
    if (json == null) {
        return json;
    }
    return {
        
        'refundable': json['refundable'] == null ? undefined : json['refundable'],
        'cancelOffsetDays': json['cancel_offset_days'] == null ? undefined : json['cancel_offset_days'],
        'source': RateRefundableSourceFromJSON(json['source']),
    };
}

export function RateRefundableResponseV2ToJSON(json: any): RateRefundableResponseV2 {
    return RateRefundableResponseV2ToJSONTyped(json, false);
}

export function RateRefundableResponseV2ToJSONTyped(value?: RateRefundableResponseV2 | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'refundable': value['refundable'],
        'cancel_offset_days': value['cancelOffsetDays'],
        'source': RateRefundableSourceToJSON(value['source']),
    };
}

